import React, { useEffect, useState } from "react";
import {
  Table,
  InputGroup,
  Form,
  Pagination,
  Modal,
  Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { FaUndo } from "react-icons/fa";
import { AiOutlineClose } from "react-icons/ai";
import Loader from "../../../components/Loader";
import Layout from "../../../components/layout/Layout";
import { getAllFreelancers } from "../../../redux/auth/authSlice";
import { Helmet } from "react-helmet";
import { mobileScroll } from "common/FunctionUtils";
import { LOCALES } from "common/constants";

const Freelancers = () => {
  // -----------------------------------translation-----------------------------------

  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  // -----------------------------------useState-----------------------------------

  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, reset } = useForm();
  const [freelancerList, setFreelancerList] = useState({
    data: [],
    pageNumber: 1,
  });
  const [isReactivate, setIsReactivate] = useState({
    show: false,
    id: 0,
    name: "",
  });

  // -----------------------------------useSelector-----------------------------------

  const { freelancers, isLoading } = useSelector((state) => state?.auth);

  // -----------------------------------Dispatch-----------------------------------

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllFreelancers());
  }, [dispatch]);

  const onSubmit = async (values) => {
    try {
      if (values?.emailForInvite === "" || values?.emailForAdd === "") {
        toast.error(t("Please enter an email for Invite or Add freelancer"));
      } else if (values?.emailForInvite !== "") {
        setLoading(true);
        await axios.post(
          `/freelancer?data=${
            values?.emailForInvite
          }&language=${language}`
        );
        setLoading(false);
        reset({ emailForInvite: "" });
        toast.success(t("Invitation has been sent successfully"));
      }
    } catch (error) {
      setLoading(false);
      toast.error(t(error?.response?.data?.message));
    } finally {
      setLoading(false);
    }
  };

  // -----------------------------------Pagination-----------------------------------

  useEffect(() => {
    const slicedArray = freelancers?.slice(
      Number(freelancerList.pageNumber + "0") - 10,
      Number(freelancerList.pageNumber + "0") || freelancers.length - 1
    );
    setFreelancerList((prevState) => ({ ...prevState, data: slicedArray }));
  }, [freelancerList.pageNumber, freelancers]);

  useEffect(() => {
    mobileScroll();
  }, []);

  const handleReativateFreelancer = async () => {
    setLoading(true);
    try {
      const url = `/freelancer/reactivate-freelancer/${isReactivate?.id}`;
      const result = await axios.post(url);
      if (result?.status === 200) {
        setLoading(false);
        toast.success(
          t("freelancer_reactivated", { name: isReactivate?.name })
        );
        setIsReactivate({
          show: false,
        });
        dispatch(getAllFreelancers());
      }
    } catch (err) {
      setLoading(false);
      toast.error(t(err?.response?.data?.message));
    }
  };

  return (
    <Layout
      className="p-4 mt-5 freelance-bg invoice-space freelance-space"
      showSidebar
      bgcolor
    >
      <Helmet>
        {language === LOCALES.EN_US ? (
          <link
            rel="canonical"
            href="https://invozio.com/dashboard/economy/freelancers"
          />
        ) : (
          <link
            rel="canonical"
            href="https://invozio.com/instrumentbrada/ekonomi/frilansare"
          />
        )}
      </Helmet>
      {(isLoading || loading) && <Loader />}

      <div className="top_sectino_freelalnce">
        <h4 className="accident_ins font-weight-bold">{t("My Freelancers")}</h4>
        <p className="mb-3">{t("Here you can invite or add freelancers")}</p>

        <div className="row m-0 invoices-row">
          <form onSubmit={handleSubmit(onSubmit)} className="w-100">
            <InputGroup className="mb-3 w-100 freelancers">
              <Form.Control
                className="border-radios-input"
                type="email"
                placeholder={t("Invite a freelancer")}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                {...register("emailForInvite")}
              />
              <button
                className="border-radios-btn"
                id="button-addon2"
                type="submit"
              >
                {t("Invite freelancer")}
              </button>
            </InputGroup>
            {/* <InputGroup className="mb-3 w-100 freelancers">
              <Form.Control
                className="border-radios-input"
                type="email"
                placeholder={t("Add a freelancer")}
                aria-label="Recipient's username"
                aria-describedby="basic-addon2"
                {...register("emailForAdd")}
              />
              <Button
                className="border-radios-btn"
                variant="outline-success"
                id="button-addon2"
                type="submit"
              >
                {t("Add Freelancer")}
              </Button>
            </InputGroup> */}
          </form>
        </div>
      </div>

      <div className="table-div">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th className="invoice_tabeletext">{t("Serial No.")}</th>
              <th className="invoice_tabeletext">{t("User id")}</th>
              <th className="invoice_tabeletext">{t("Name")}</th>
              <th className="invoice_tabeletext">{t("email")}</th>
              <th className="invoice_tabeletext">{t("Phone Number")}</th>
              <th className="invoice_tabeletext">{t("Status")}</th>
              <th className="invoice_tabeletext">{t("Action")}</th>
            </tr>
          </thead>
          <tbody>
            {freelancerList?.data?.map((items, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{items?.userId}</td>
                  <td>
                    {items?.signUpUser?.firstName} {items?.signUpUser?.lastName}
                  </td>
                  <td>{items?.signUpUser?.email}</td>
                  <td>{items?.signUpUser?.phoneNo}</td>
                  <td>
                    {items?.signUpUser?.isActive ? t("Active") : t("Inactive")}
                  </td>
                  <td>
                    <Button
                      className="color-bg cursor-pointer"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      title={t("Reactivate")}
                      onClick={() =>
                        setIsReactivate({
                          show: true,
                          id: items.userId,
                          name:
                            items?.signUpUser?.firstName +
                            " " +
                            items?.signUpUser?.lastName,
                        })
                      }
                      disabled={items?.signUpUser?.isActive}
                    >
                      <FaUndo size={13} id="top" color="white" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
      <Pagination className="justify-content-center">
        {freelancers?.length > 10 &&
          new Array(Math.ceil(freelancers?.length / 10))
            .fill(undefined)
            .map((_, key) => (
              <Pagination.Item
                activeLabel=""
                active={freelancerList?.pageNumber - 1 === key}
                key={key}
                onClick={() => {
                  setFreelancerList((prevState) => ({
                    ...prevState,
                    pageNumber: key + 1,
                  }));
                }}
              >
                {key + 1}
              </Pagination.Item>
            ))}
      </Pagination>

      {isReactivate?.show && (
        <Modal
          show={true}
          onHide={() =>
            setIsReactivate({
              show: false,
            })
          }
        >
          <Modal.Header>
            <Modal.Title>{t("Reactivate Freelancer")}</Modal.Title>
            <AiOutlineClose
              className="ml-auto cursor-pointer"
              size={24}
              onClick={() =>
                setIsReactivate({
                  show: false,
                })
              }
            />
          </Modal.Header>
          <Modal.Body>
            {t(`Are you sure you want to reactivate`)}{" "}
            {`${isReactivate?.name}?`}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="outline_btn_new"
              variant="secondary"
              onClick={() =>
                setIsReactivate({
                  show: false,
                })
              }
            >
              {t("No")}
            </button>
            <Button
              className="text-light delete_customer new_theme_btn "
              variant="primary"
              onClick={handleReativateFreelancer}
            >
              {t("Yes")}
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </Layout>
  );
};
export default Freelancers;
